module.exports = "/_next/static/images/icon-selected-active-797ba7a0.png";